import LogoEssentiaGroup from "./assets/img/logo-essentia-group.svg";
import LogoEssentia21anos from "./assets/img/logo_essentia_21_anos_BR.svg";
import LogoEssentia21anosENG from "./assets/img/logo_essentia_21_anos_ENG.svg";
import LogoEssentia21anosESP from "./assets/img/logo_essentia_21_anos_ESP.svg";
import EssentiaPharma from "./assets/img/essentia-pharma.svg";
import EssentialNutrition from "./assets/img/essential-nutrition.svg";
import Noorskin from "./assets/img/noorskin.svg";
import BeGenerous from "./assets/img/be-generous.svg";
import EasyHealth from "./assets/img/easy-health.svg";

// Dark Logos para o carrossel
import EssentiaPharmaDark from "./assets/img/qualidade/pharma-dark.svg";
import EssentialNutritionDark from "./assets/img/qualidade/nutrition-dark.svg";
import NoorskinDark from "./assets/img/qualidade/noorskin-dark.svg";
import BeGenerousDark from "./assets/img/qualidade/be-generous-dark.svg";
import TechnologiesDark from "./assets/img/qualidade/technologies-dark.svg";

import LaboratorioPharma from "./assets/img/laboratorio-essentia-pharma.jpg";
import BrainstormEssentialNutrition from "./assets/img/brainstorm-coffee-essential-nutrition.jpg";
import NaturalLightNoorskin from "./assets/img/natural-light-noorskin.jpg";
import Omega3BeGenerous from "./assets/img/omega-3-be-generous.jpg";
import UsuarioEasyHealth from "./assets/img/usuario-easy-health.jpg";
import LogoGroup from "./assets/img/logo-essentia-group-white.svg";
import Experience from "./assets/img/essentia-experience.svg";
import ExperienceP from "./assets/img/essentia-experience-p.svg";
import EssentiaExperienceAmbiente from "./assets/img/essentia-experience-ambiente.jpg";

import Qualidade20Anos from "./assets/img/qualidade/20-anos-qualidade.png";
import QualidadeCabecalhoPoster from "./assets/img/qualidade/cabecalho.png";
import QualidadeQueSeVive from "./assets/img/qualidade/qualidade-que-se-vive.png";
import NextSlide from "./assets/img/qualidade/next-slide.svg";

// Carousel Slide Assets - Slide 1 (Pharma)
import Slide1Pharma from "./assets/img/qualidade/slide1-pharma.png";
import Slide1PackPharma from "./assets/img/qualidade/slide1-pack-pharma.png";
import Slide1LaboratorioInjetaveis from "./assets/img/qualidade/slide1-laboratorio-injetaveis.png";

// Carousel Slide Assets - Slide 2 (Nutrition)
import Slide2Nutrition from "./assets/img/qualidade/slide2-nutrition.png";
import Slide2Produtos from "./assets/img/qualidade/slide2-produtos.png";

// Carousel Slide Assets - Slide 3 (Noorskin)
import Slide3Cremes from "./assets/img/qualidade/slide3-cremes.png";
import Slide3Ewg from "./assets/img/qualidade/slide3-ewg.png";
import Slide3Noorskin from "./assets/img/qualidade/slide3-noorskin.png";
import Slide3Noorskin1 from "./assets/img/qualidade/slide3-noorskin1.png";

// Carousel Slide Assets - Slide 4 (Technologies)
import Slide4Easy from "./assets/img/qualidade/slide4-easy.png";
import Slide4Tech from "./assets/img/qualidade/slide4-tech.png";

// Carousel Slide Assets - Slide 5 (Be Generous)
import Slide5BeGenerous from "./assets/img/qualidade/slide5-be-generous.png";
import Slide5Bebe from "./assets/img/qualidade/slide5-bebe.png";
import Slide5CapsBeGenerous from "./assets/img/qualidade/slide5-caps-be-generous.png";

// Banner Qualidade Assets
import BannerMateriasPrimas from "./assets/img/qualidade/banner-materias-primas-premium.jpg";
import BannerControleQualidade from "./assets/img/qualidade/banner-controle-de-qualidade.jpg";
import BannerPesquisaInovacao from "./assets/img/qualidade/banner-pesquisa-e-inovacao.jpg";
import BannerCertificados from "./assets/img/qualidade/banner-nossos-certificados.jpg";

// Ícones Qualidade Assets
import IconMateriasPrimas from "./assets/img/qualidade/materias-primas-premium.svg";
import IconControleQualidade from "./assets/img/qualidade/controle-de-qualidade.svg";
import IconPesquisaInovacao from "./assets/img/qualidade/pesquisa-e-inovacao.svg";
import IconCertificados from "./assets/img/qualidade/nossos-certificados.svg";
import ImagemCertificados from "./assets/img/qualidade/certificados.png";

// Testimonials Background
import TestimonialsBackground from "./assets/img/qualidade/bottom-testimonials-carousel.png";

import MobileLaboratorioPharma from "./assets/img/mobile/laboratorio-essentia-pharma.jpg";
import MobileBrainstormEssentialNutrition from "./assets/img/mobile/brainstorm-coffee-essential-nutrition.jpg";
import MobileNaturalLightNoorskin from "./assets/img/mobile/natural-light-noorskin.jpg";
import MobileOmega3BeGenerous from "./assets/img/mobile/omega-3-be-generous.jpg";
import MobileUsuarioEasyHealth from "./assets/img/mobile/usuario-easy-health.jpg";
import MobileEssentiaExperienceAmbiente from "./assets/img/mobile/essentia-experience-ambiente.jpg";
import MobileQualidadeQueSeVive from "./assets/img/mobile/qualidade/qualidade-que-se-vive.png";

// Mobile Qualidade Brands Images
import MobileQualidadePharma from "./assets/img/mobile/qualidade/pharma.png";
import MobileQualidadeNutrition from "./assets/img/mobile/qualidade/nutrition.png";
import MobileQualidadeNoorskin from "./assets/img/mobile/qualidade/noorskin.png";
import MobileQualidadeBeGenerous from "./assets/img/mobile/qualidade/be-generous.png";
import MobileQualidadeTechnologies from "./assets/img/mobile/qualidade/technologies.png";
import MobileCertificados from "./assets/img/mobile/qualidade/certificados.png";

// URLs dos vídeos no S3
const QualidadeCabecalho =
  "https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/cabecalho.mp4";
const QualidadeCabecalhoMobile =
  "https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/cabecalho-mobile.mp4";

export const desktopImages = {
  LogoEssentiaGroup,
  LogoEssentia21anos,
  LogoEssentia21anosENG,
  LogoEssentia21anosESP,
  EssentiaPharma,
  EssentialNutrition,
  Noorskin,
  BeGenerous,
  EasyHealth,

  // Dark Logos
  EssentiaPharmaDark,
  EssentialNutritionDark,
  NoorskinDark,
  BeGenerousDark,
  TechnologiesDark,

  LaboratorioPharma,
  BrainstormEssentialNutrition,
  NaturalLightNoorskin,
  Omega3BeGenerous,
  UsuarioEasyHealth,
  LogoGroup,
  Experience,
  ExperienceP,
  EssentiaExperienceAmbiente,
  QualidadeCabecalho,
  QualidadeCabecalhoPoster,
  Qualidade20Anos,
  QualidadeQueSeVive,
  NextSlide,

  // Slide 1 - Pharma
  Slide1Pharma,
  Slide1PackPharma,
  Slide1LaboratorioInjetaveis,

  // Slide 2 - Nutrition
  Slide2Nutrition,
  Slide2Produtos,

  // Slide 3 - Noorskin
  Slide3Cremes,
  Slide3Ewg,
  Slide3Noorskin,
  Slide3Noorskin1,

  // Slide 4 - Technologies
  Slide4Easy,
  Slide4Tech,

  // Slide 5 - Be Generous
  Slide5BeGenerous,
  Slide5Bebe,
  Slide5CapsBeGenerous,

  // Banner Qualidade Assets
  BannerMateriasPrimas,
  BannerControleQualidade,
  BannerPesquisaInovacao,
  BannerCertificados,

  // Ícones Qualidade Assets
  IconMateriasPrimas,
  IconControleQualidade,
  IconPesquisaInovacao,
  IconCertificados,

  // Imagem Certificados
  ImagemCertificados,

  // Testimonials Background
  TestimonialsBackground,
};

export const mobileImages = {
  LaboratorioPharma: MobileLaboratorioPharma,
  BrainstormEssentialNutrition: MobileBrainstormEssentialNutrition,
  NaturalLightNoorskin: MobileNaturalLightNoorskin,
  Omega3BeGenerous: MobileOmega3BeGenerous,
  UsuarioEasyHealth: MobileUsuarioEasyHealth,
  EssentiaExperienceAmbiente: MobileEssentiaExperienceAmbiente,
  QualidadeQueSeVive: MobileQualidadeQueSeVive,
  QualidadeCabecalho: QualidadeCabecalhoMobile,

  // Mobile Qualidade Brands Images
  QualidadePharma: MobileQualidadePharma,
  QualidadeNutrition: MobileQualidadeNutrition,
  QualidadeNoorskin: MobileQualidadeNoorskin,
  QualidadeBeGenerous: MobileQualidadeBeGenerous,
  QualidadeTechnologies: MobileQualidadeTechnologies,
  Certificados: MobileCertificados,
};
